import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import "../../constants/css/custom_styles.css";
import { HiHome, HiOutlineVideoCamera } from "react-icons/hi";
import { getUserRole } from "../../utils/localStoarege";
import { AiOutlineAppstore } from "react-icons/ai";
import { FaUserDoctor } from "react-icons/fa6";
import { toast } from "react-toastify";
import CustomLoading from "../customLoading/CustomLoading";
import { getDoctorCenters } from "../../services/doctor/doctor_view_dashboard";
import { MdAssistant, MdOutlineAccountBalanceWallet } from "react-icons/md";

const DoctorSidebar = () => {
  const location = useLocation();
  let isTab = useMediaQuery({ query: "(max-width: 768px)" });
  const [isOpen, setIsOpen] = useState(isTab ? false : true);
  const [centers, setCenters] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const fetchCenters = async () => {
    setLoading(true);
    try {
      let res = await getDoctorCenters("?page_size=50");
      setLoading(false);
      if (res.status === 200) {
        setCenters(res.data.results);
      } else {
        toast.error("Unable to fetch centers");
      }
    } catch (error) {
      console.error("Error fetching centers:", error);
    }
  };

  useEffect(() => {
    fetchCenters();
  }, []);

  const [isActive, setIsActive] = useState({
    home: false,
    finances: false,
    doctor: false,
    video_call: false,
    enquiry: false,
  });

  useEffect(() => {
    setIsOpen(!isTab);
  }, [isTab]);

  useEffect(() => {
    const path = location.pathname;

    setIsActive({
      home: path.includes("/doctor/home"),
      finances: path === "/doctor/finances",
      doctor: path === "/doctor",
      video_call: path === "/video-call",
      enquiry: path === "/enquiry" || path === "/enquiry/add",
    });
  }, [location.pathname]);

  const handleIsActive = (key) => {
    setIsActive((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  return (
    <motion.div
      initial={{ x: -250 }}
      animate={{ x: isOpen ? 0 : -250 }}
      className="bg-secondary text-[#ffffff] shadow-xl w-[10rem] max-w-[10rem] h-full md:overflow-y-scroll 2xl:overflow-hidden md:relative  fixed pl-2"
    >
      <div className="flex flex-col justify-between h-full">
        <div
          className={`text-xs whitespace-pre pb-2 pt-4 flex items-center flex-row gap-2 font-bold ${isOpen ? "block" : "hidden"}`}
        >
          <HiHome size={18} />
          Admin View
        </div>
        <hr className="border-white my-2" />
        <div className="overflow-y-auto flex-1">
          {/* Menus */}
          <div className="flex flex-col h-full">
            {/* First */}
            <ul className="whitespace-pre px-2.5 text-[0.9rem] text-xs py-3 flex flex-col gap-2 font-medium scrollbar-thin h-full md:h-full">
              {<li>
                <NavLink
                  to="/doctor/home"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.home ? "text-white bg-primary rounded-md" : ""
                    }`}
                  onClick={() => handleIsActive("home")}
                >
                  <AiOutlineAppstore size={18} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    Dashboard
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/doctor/finances"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.finances ? "text-white bg-primary rounded-md" : ""
                    }`}
                  onClick={() => handleIsActive("finances")}
                >
                  <MdOutlineAccountBalanceWallet size={18} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    Monthly Stats
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/doctor"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.doctor ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("doctor")}
                >
                  <FaUserDoctor size={18} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    HUD View
                  </p>
                </NavLink>
              </li>}
              {<li className="pb-2 border-b border-white">
                <NavLink
                  to="/video-call"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.video_call ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("video_call")}
                >
                  <HiOutlineVideoCamera size={18} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    Video Call
                  </p>
                </NavLink>
              </li>}
              {<li>
                <NavLink
                  to="/enquiry"
                  className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.enquiry ? "bg-primary rounded-md" : ""}`}
                  onClick={() => handleIsActive("enquiry")}
                >
                  <MdAssistant size={18} />
                  <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                    Enquiry
                  </p>
                </NavLink>
              </li>}
              {
                isLoading ?
                  <div className="flex justify-center items-center">
                    <CustomLoading />
                  </div>
                  :
                  centers.map((center, index) => (
                    <li key={index}>
                      <NavLink
                        to={`/doctor/${center.name.toLowerCase()}`}
                        state={center.name}
                        className={({ isActive }) =>
                          `flex gap-3 pl-1 pr-1 py-2 ${isActive ? "bg-primary rounded-md" : ""
                          }`
                        }
                      >
                        <FaUserDoctor size={18} />
                        <p className={`whitespace-pre ${isOpen ? "block" : "hidden"}`}>
                          {center.name}
                        </p>
                      </NavLink>
                    </li>
                  ))
              }
            </ul>
          </div>

        </div>
        <p className="text-[0.5rem] mb-4">
          <Link to={getUserRole() === "developer" ? "/hud-developer" : null}>
            © Developed By: Rashail Tech. Labs
          </Link>
        </p>
      </div>
    </motion.div>
  );
};

export default DoctorSidebar;
